export default __webpack_public_path__ + "static/media/bg_img_home.e87b636d.svg";